<template>
  <v-list-item
    :link="true"
    v-bind="passthroughAttrs"
    density="compact"
    class="tickets-action-menu__item"
    :class="itemClasses"
    @click="onClick"
  >
    <template #prepend>
      <v-icon
        :icon="resolvedIcon"
        size="18"
        class="tickets-action-menu__item-icon"
      />
    </template>
    <v-list-item-title class="tickets-action-menu__item-label">
      <slot />
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { resolveActionMenuIcon } from "@/utils/ticketActionMenuIcons.js";

export default {
  name: "TicketsActionMenuItem",
  inheritAttrs: false,
  emits: ["click"],
  props: {
    destructive: {
      type: Boolean,
      default: null,
    },
    divider: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    passthroughAttrs() {
      const { onClick, ...rest } = this.$attrs;
      return rest;
    },
    labelText() {
      const nodes = this.$slots.default?.() || [];
      return nodes
        .map((node) => {
          if (typeof node.children === "string") return node.children;
          if (Array.isArray(node.children)) {
            return node.children
              .map((child) => (typeof child === "string" ? child : ""))
              .join("");
          }
          return "";
        })
        .join("")
        .trim();
    },
    resolvedMeta() {
      return resolveActionMenuIcon(this.labelText);
    },
    resolvedIcon() {
      return this.icon || this.resolvedMeta.icon;
    },
    isDestructive() {
      if (this.destructive !== null) return this.destructive;
      return this.resolvedMeta.destructive;
    },
    itemClasses() {
      return {
        "tickets-action-menu__item--destructive": this.isDestructive,
        "tickets-action-menu__item--with-divider": this.divider,
      };
    },
  },
  methods: {
    onClick(event) {
      const handler = this.$attrs.onClick;
      if (typeof handler === "function") {
        handler(event);
      } else if (Array.isArray(handler)) {
        handler.forEach((fn) => fn(event));
      }
      this.$emit("click", event);
    },
  },
};
</script>
